import { render, staticRenderFns } from "./MsgToUploadFile.vue?vue&type=template&id=2e01b15e&scoped=true"
import script from "./MsgToUploadFile.vue?vue&type=script&lang=js"
export * from "./MsgToUploadFile.vue?vue&type=script&lang=js"
import style0 from "./MsgToUploadFile.vue?vue&type=style&index=0&id=2e01b15e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e01b15e",
  null
  
)

export default component.exports